export default __webpack_public_path__ + "static/media/Subtract.8ca62a5c.svg";